export type POSThemeId = 'classic' | 'ocean' | 'forest' | 'sunset' | 'royal' | 'midnight';

export const POS_THEME_LIST: { id: POSThemeId; name: string; swatch: string }[] = [
  { id: 'classic',  name: 'MenuMaster Red', swatch: '#E02A2A' },
  { id: 'ocean',    name: 'Warm Coral',     swatch: '#C62020' },
  { id: 'forest',   name: 'Sage',           swatch: '#388E3C' },
  { id: 'sunset',   name: 'Spice',          swatch: '#D97706' },
  { id: 'royal',    name: 'Burgundy',       swatch: '#8B1111' },
  { id: 'midnight', name: 'Red Night',      swatch: '#7F1D1D' },
];

export const POS_THEMES: Record<POSThemeId, {
  bg: string; surface: string; border: string; shadow: string; mesh: string;
  accent: string; payGradient: string; kotBorder: string; isDark: boolean;
}> = {
  classic: {
    bg: '', surface: '', border: '', shadow: '', mesh: '',
    accent: '#E02A2A', payGradient: 'linear-gradient(135deg,#E02A2A,#B71C1C)', kotBorder: '#E02A2A',
    isDark: false,
  },
  ocean: {
    bg: '#dbeafe',
    surface: 'rgba(240,249,255,0.92)',
    border: 'rgba(125,211,252,0.55)',
    shadow: '0 8px 32px rgba(2,132,199,0.14)',
    mesh: 'radial-gradient(ellipse at 15% 60%, rgba(14,165,233,0.13) 0%, transparent 55%), radial-gradient(ellipse at 85% 20%, rgba(56,189,248,0.10) 0%, transparent 55%)',
    accent: '#C62020',
    payGradient: 'linear-gradient(135deg,#E02A2A,#B71C1C)',
    kotBorder: '#C62020',
    isDark: false,
  },
  forest: {
    bg: '#d1fae5',
    surface: 'rgba(240,253,244,0.92)',
    border: 'rgba(134,239,172,0.55)',
    shadow: '0 8px 32px rgba(22,163,74,0.14)',
    mesh: 'radial-gradient(ellipse at 15% 60%, rgba(34,197,94,0.13) 0%, transparent 55%), radial-gradient(ellipse at 85% 20%, rgba(22,163,74,0.10) 0%, transparent 55%)',
    accent: '#16a34a',
    payGradient: 'linear-gradient(135deg,#16a34a,#15803d)',
    kotBorder: '#16a34a',
    isDark: false,
  },
  sunset: {
    bg: '#fef3c7',
    surface: 'rgba(255,251,235,0.92)',
    border: 'rgba(252,211,77,0.55)',
    shadow: '0 8px 32px rgba(234,88,12,0.14)',
    mesh: 'radial-gradient(ellipse at 15% 60%, rgba(251,146,60,0.15) 0%, transparent 55%), radial-gradient(ellipse at 85% 20%, rgba(234,88,12,0.10) 0%, transparent 55%)',
    accent: '#D97706',
    payGradient: 'linear-gradient(135deg,#D97706,#B45309)',
    kotBorder: '#D97706',
    isDark: false,
  },
  royal: {
    bg: '#FBE9E7',
    surface: 'rgba(255,248,247,0.94)',
    border: 'rgba(224,42,42,0.32)',
    shadow: '0 8px 32px rgba(183,28,28,0.14)',
    mesh: 'radial-gradient(ellipse at 15% 60%, rgba(224,42,42,0.13) 0%, transparent 55%), radial-gradient(ellipse at 85% 20%, rgba(198,32,32,0.10) 0%, transparent 55%)',
    accent: '#8B1111',
    payGradient: 'linear-gradient(135deg,#B71C1C,#8B1111)',
    kotBorder: '#8B1111',
    isDark: false,
  },
  midnight: {
    bg: '#0f172a',
    surface: 'rgba(30,41,59,0.88)',
    border: 'rgba(51,65,85,0.75)',
    shadow: '0 8px 32px rgba(0,0,0,0.45)',
    mesh: 'radial-gradient(ellipse at 15% 60%, rgba(224,42,42,0.16) 0%, transparent 55%), radial-gradient(ellipse at 85% 20%, rgba(183,28,28,0.12) 0%, transparent 55%)',
    accent: '#FF5A5A',
    payGradient: 'linear-gradient(135deg,#E02A2A,#B71C1C)',
    kotBorder: '#FF5A5A',
    isDark: true,
  },
};
